import React, { ReactNode } from 'react';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

// import {
//   Row,
//   Col,
//   Card,
// } from 'react-bootstrap';
// import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Spin } from "antd";

// Auth
// import { useAuthContext } from '../../../../v5/auth/use-auth-context.js';
// import { useRouter } from '../../../../v5/auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../../v5/utils/store.tsx';
import slice from './slice.tsx';
import jobFormSlice, { driverMarkerIcon, arrowMarkerIcon, defaultMarkerIcon } from '../../slice.tsx';

// enums
import { getDefLatLngZoomV4, convertCoordToLatLng, validateLatLng, dinamicMultiZoom } from '../../../../../v5/utils/utils.tsx';
// import {  } from '../../../../../v5/utils/enums.tsx';

// import {  } from '../../../manage/jobs/jobTypes/slice.tsx';

// components
// import MainContainer from '../../../../../v5/components/container/MainContainer.jsx';
import GoogleMap, { addMarker, clearAllMarkers, addPolyline, clearAllPolyline } from '../../../../../v5/components/googleMap/GoogleMap.jsx';
import { title } from 'process';

// import { ReactComponent as XIcon } from "../../../../../v5/assets/icons/smallX.svg";

// ----------------------------------------------------------------------


const Map = () => {
  const defaultLatLngZoom: any = getDefLatLngZoomV4();
  // const location = useLocation();
  // const router = useRouter();

  const { show, values, coordinates } = useTypedSelector((state: RootState) => state.jobFormJobSummarySlice);
  const { latestLocationDrivers, directions } = useTypedSelector((state: RootState) => state.jobFormSlice);
  const dispatch = useDispatch<AppDispatch>();

  const [map, setMap] = React.useState<any>(null);

  const latestLocationDriversMarkersRef = React.useRef<Array<google.maps.Marker>>([]);
  const driversPathMarkersRef = React.useRef<Array<google.maps.Marker>>([]);
  const polylineRef = React.useRef<Array<google.maps.Polyline>>([]);
  const defaultLocationsMarkersRef = React.useRef<Array<google.maps.Marker>>([]);
  const routePolylineRef = React.useRef<Array<google.maps.Polyline>>([]);

  const [showTrafficLayer, setShowTrafficLayer] = React.useState<any>(false);
  const [customButtons, setCustomButtons] = React.useState<Array<any>>([]);


  React.useEffect(() => {
    if(show){
      setShowTrafficLayer(false)
    }
  }, [show]);

  React.useEffect(() => {
    setCustomButtons([
      {
        element: 'button',
        text: showTrafficLayer ? 'Hide traffic' : 'Show traffic',
        className: 'btn btn-custom-outlined btn-sm m-8',
        style: {
          position: 'absolute',
          bottom: '25px',
          right: '10px',
        },
        visible: true,
        disabled: false,
        callback: (e: any) => setShowTrafficLayer(!showTrafficLayer),
      }
    ]);
  }, [showTrafficLayer]);


  React.useEffect(() => {
    clearAllMarkers(latestLocationDriversMarkersRef);
    clearAllMarkers(driversPathMarkersRef);
    clearAllMarkers(defaultLocationsMarkersRef);
    clearAllPolyline(polylineRef);

    if(show){
      if(latestLocationDrivers && latestLocationDrivers.length > 0){
        latestLocationDrivers.forEach((item: any, i: number) => {
          addMarker(latestLocationDriversMarkersRef, {
            map: map,
            ...item,
            ...driverMarkerIcon(item.driverName, '#43936C'),
          })
          
          addMarker(driversPathMarkersRef, {
            map: map,
            ...item,
            ...arrowMarkerIcon(latestLocationDrivers, item, i),
          })
        });
        
        addPolyline(polylineRef, latestLocationDrivers.map((x: any) => x.position), {
          map: map,
          strokeColor: "#185CFF",
          strokeOpacity: 0.5,
          strokeWeight: 4,
        });
      }


      if(coordinates && coordinates.length > 0){
        let count = 1;
        coordinates.forEach((item: any) => {
          let latLng = convertCoordToLatLng(item.coordinates);
          if(latLng){
            if(validateLatLng(latLng?.lat, latLng?.lng)){
              addMarker(defaultLocationsMarkersRef, {
                map: map,
                position: {
                  lat: latLng?.lat,
                  lng: latLng?.lng,
                },
                title: item?.obj?.address,
                spiderfy: true,
                ...defaultMarkerIcon((count).toString()),
              })
              count = count + 1;
            }
          }
        });
        
        dinamicMultiZoom(map, defaultLocationsMarkersRef.current);
      }
    }
  }, [show, coordinates, map, window.google])


  React.useEffect(() => {
    if(show){
      clearAllPolyline(routePolylineRef);

      if(directions && directions.routes && directions.routes.length > 0){
        let route = directions.routes[0];
  
        addPolyline(routePolylineRef, route.overview_path, {
          map: map,
          strokeColor: "#185CFF",
          strokeOpacity: 0.5,
          strokeWeight: 4,
        });
      }
    }
  }, [show, map, directions, window.google]);


  return <Spin spinning={false}>
    <div style={{ height: 'calc(100vh - 133px)' }}>
      <GoogleMap
        canConextMenu={false}
        showTrafficLayer={showTrafficLayer}
        customButtons={customButtons}
        options={{
          center: defaultLatLngZoom.coord,
          zoom: defaultLatLngZoom.zoom,
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: true,
          cameraControl: false,
          fullscreenControl: false,
          gestureHandling: "cooperative",
        }}
        onLoad={(map: any, ref: any) => {
          setMap(map);
        }}
      />
    </div>
  </Spin>
}

export default Map;
